export const toNumber = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
};

export const round2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100;

/**
 * Reducing balance EMI schedule
 * P = principal
 * r = monthly interest rate (annualRate/12/100)
 * n = months
 *
 * EMI = P*r*(1+r)^n / ((1+r)^n - 1)
 */
export const buildReducingEmiSchedule = ({ principal, annualRate, months }) => {
    const P = toNumber(principal);
    const n = Math.max(0, parseInt(months, 10) || 0);
    const annual = toNumber(annualRate);

    if (P <= 0 || n <= 0) return { emi: 0, schedule: [] };

    // If rate is 0%, EMI is simple division
    const monthlyRate = annual / 12 / 100;

    let emi =
        monthlyRate === 0
            ? P / n
            : (P * monthlyRate * Math.pow(1 + monthlyRate, n)) /
            (Math.pow(1 + monthlyRate, n) - 1);

    emi = round2(emi);

    const schedule = [];
    let balance = P;

    for (let m = 1; m <= n; m++) {
        const opening = balance;
        const interest = round2(opening * monthlyRate);

        // principal = emi - interest
        let principalPaid = round2(emi - interest);

        // Adjust last month to close balance perfectly (avoid rounding residue)
        if (m === n) {
            principalPaid = round2(opening);
            emi = round2(principalPaid + interest);
        }

        const closing = round2(opening - principalPaid);

        schedule.push({
            month: m,
            opening: round2(opening),
            emi: round2(emi),
            interest,
            principal: principalPaid,
            closing: closing < 0 ? 0 : closing,
        });

        balance = closing;
    }

    return { emi, schedule };
};
